var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8AddUserMaleSkinType750(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#edb405",
    d: "M24,37c-5,0-5-6-5-6v-6h10v6C29,31,29,37,24,37z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#edbd28",
    d: "M35,19c0,1.105-0.895,2-2,2s-2-0.895-2-2s0.895-2,2-2S35,17.895,35,19 M17,19c0-1.105-0.895-2-2-2 s-2,0.895-2,2s0.895,2,2,2S17,20.105,17,19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffca28",
    d: "M33,13c0-7.637-18-4.973-18,0v7c0,4.973,4.027,9,9,9s9-4.027,9-9V13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M24,4c-6.074,0-10,4.926-10,11v2.285L16,19v-5l12-4l4,4v5l2-1.742V15c0-4.023-1.039-8.016-6-9l-1-2 H24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#784719",
    d: "M27,19c0-0.551,0.449-1,1-1s1,0.449,1,1s-0.449,1-1,1S27,19.551,27,19 M19,19c0,0.551,0.449,1,1,1 s1-0.449,1-1s-0.449-1-1-1S19,18.449,19,19"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4fc3f7",
    d: "M29,31c0,0-1,4-5,4s-5-4-5-4S8,32.984,8,44h32C40,33.023,29,31,29,31"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#01579b",
    d: "M24,37c5,0,6.746-3.93,6.949-5.43C29.793,31.148,29,31,29,31s-1,4-5,4s-5-4-5-4 s-0.797,0.145-1.953,0.566C17.254,33.063,19,37,24,37z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#43a047",
    d: "M46,38c0,5.523-4.477,10-10,10s-10-4.477-10-10s4.477-10,10-10S46,32.477,46,38"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34,32h4v12h-4V32z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30,36h12v4H30V36z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8AddUserMaleSkinType750);
export default __webpack_public_path__ + "static/media/icons8-add-user-male-skin-type-7-50.8f6259eeadd6fadaec40ce3367a05752.svg";
export { ForwardRef as ReactComponent };